// Packages
import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { useNavigate } from "react-router-dom"
//	Utils
import { setPid } from "lib/navigation-util"
import { getDY_SR } from "stackerConfig"
import { useSelector } from "react-redux"

function LinkAdapter({
  to,
  isHomePage,
  children,
  isHardPageLoad,
  aria,
  target,
  rel,
  tabIndex,
  className,
  style,
  "data-index": dataIndex,
  customClick,
  baseProduct,
  isThirdParty,
}) {
  //const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isSPA, routerLocation } = useSelector((state) => {
    return {
      isSPA: state.application.isSPA,
      routerLocation: state.router.location,
    }
  })
  // Required for Navigation to PDP or opening QuickView modal
  const updateProductId = (baseProduct) => {
    setPid(baseProduct)
  }

  const customOnClick = useCallback(
    (e) => {
      if (customClick) {
        customClick(e)
      }
      if (isHardPageLoad || isThirdParty || !isSPA) {
        return true
      }

      if (baseProduct) {
        updateProductId(baseProduct)
      }

      navigate(to)
      e.preventDefault()
      return false
    },
    [
      baseProduct,
      customClick,
      navigate,
      isHardPageLoad,
      isSPA,
      isThirdParty,
      to,
    ]
  )

  const handleOnClick = useCallback(
    (e) => {
      if (baseProduct) {
        updateProductId(baseProduct)
      }

      if (customClick) {
        customClick(e)
      }
    },
    [baseProduct, customClick]
  )

  if (!to) {
    return null
  }

  let replace = false
  if (routerLocation && routerLocation.pathname) {
    replace = to === routerLocation.pathname
  }
  if (isHardPageLoad || isThirdParty || !isSPA) {
    // isHardPageLoad - To Hard Load any page which is NOT under React Route control
    // Example - [Home, Customer Service Shopping Bag/Checkout from Home, emailPreferences from Order-Confirmation Page]
    // isThirdParty - For Third party websites
    const { baseURL } = getDY_SR().config.global
    let location = to

    if (!isThirdParty) {
      location = `${baseURL}${to}`

      if (isHomePage) {
        location = baseURL ? `${baseURL}.html` : "/"
      }
    }

    return (
      <a
        className={className}
        target={target}
        tabIndex={tabIndex}
        href={location}
        rel={rel}
        {...(aria && aria.label && { "aria-label": aria.label })}
        onClick={customOnClick}
        onKeyPress={customOnClick}
      >
        {children}
      </a>
    )
  }

  return (
    <Link
      className={className}
      style={style}
      data-index={dataIndex}
      target={target}
      rel={rel}
      tabIndex={tabIndex}
      to={to}
      {...(aria && aria.label && { "aria-label": aria.label })}
      onClick={handleOnClick}
      onKeyPress={handleOnClick}
      replace={replace}
    >
      {children}
    </Link>
  )
}

LinkAdapter.propTypes = {
  to: PropTypes.string,
  isHomePage: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  isHardPageLoad: PropTypes.bool,
  aria: PropTypes.object,
  target: PropTypes.string,
  rel: PropTypes.string,
  tabIndex: PropTypes.string,
  dispatch: PropTypes.func,
  isSPA: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  "data-index": PropTypes.number,
  customClick: PropTypes.func,
  baseProduct: PropTypes.string,
  isThirdParty: PropTypes.bool,
  routerLocation: PropTypes.object,
}

export default LinkAdapter
